import { Composer, useChatConfig } from '@formant/chat';
import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '../../auth/AuthProvider';
import { ChatGreetingHead, useChatPage } from '../../components/chat/ChatPage';
import { greetingLine } from '../../components/chat/chat-page-helpers';

/**
 * Fresh-session greeting for the full-page chat (`/chat`, DEV-16971): Formant
 * logo + a friendly time-of-day greeting + a centered composer. Sending the
 * first message creates a PA session and transitions into the conversation
 * (`/chat/$threadId`), where the message is delivered.
 */
function ChatGreetingRoute() {
  const { startWithMessage, session } = useChatPage();
  const { name, email } = useAuth();
  // Mirror PaChatView's gate: no Theopolis origin → no voice transcription →
  // don't show a mic that can only error.
  const { voiceEnabled } = useChatConfig();
  const line = greetingLine(new Date().getHours(), name, email);

  return (
    <div className="chat-page__greeting">
      <ChatGreetingHead line={line} />
      <div className="chat-page__greeting-composer">
        <Composer
          hideDictation={!voiceEnabled}
          onSend={startWithMessage}
          disabled={false}
          busy={session.createThreadPending}
          autosendOnDictation={true}
          pushToDictateKey="d"
          thinking={session.thinking}
          onThinkingChange={session.setThinking}
        />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/chat/')({ component: ChatGreetingRoute });
